// extracted by mini-css-extract-plugin
export default {"tabContainer":"prodTabs_tabContainer__7BSkS","tabsStyle":"prodTabs_tabsStyle__hvc50"};